<template>
  <div
    :class="{ required: data.required }"
    class="field">
    <label>{{ $t(data.label) }}</label>
    <input
      type="text"
      :value="input"
      @input="change($event.target.value)"
      autocomplete="off"
      spellcheck="off"
      :name="data.hasOwnProperty('name') ? data.name : `text-input-${_uid}`"
      :required="data.required"
      :autofocus="data.autofocus"
      :placeholder="$t(data.placeholder)"
      :disabled="data.disabled">
  </div>
</template>

<script>

export default {
  name: 'TextInput',
  props: {
    data: {
      type: Object,
      required: true
    },
    value: {
      validator: (value) => {
        return (value === null || ['string', 'number', 'undefined'].includes(typeof value))
      },
      required: true
    }
  },
  data () {
    return {
      input: this.value
    }
  },
  computed: {
  },
  methods: {
    change (value) {
      this.input = value

      this.$emit('input', this.input)
    }
  }
}
</script>

<style scoped>

</style>
